'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Message;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
function Message(_ref) {
	var author = _ref.author;
	var text = _ref.text;

	return _react2.default.createElement(
		'div',
		{ className: 'vtChat-Message' },
		_react2.default.createElement(
			'strong',
			{ className: 'vtChat-Message-author' },
			_react2.default.createElement(_reactIntl.FormattedMessage, {
				id: 'vtChat.Message.author',
				values: {
					firstName: author.firstName,
					lastName: author.lastName
				}
			})
		),
		_react2.default.createElement(
			'span',
			{ className: 'vtChat-Message-text' },
			text
		)
	);
}

Message.propTypes = {
	author: _react.PropTypes.object.isRequired,
	text: _react.PropTypes.string.isRequired
};